import '../App.css';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../Header';
import DeviceHeader from './DeviceHeader';
import V2Card from '../V2Card';

function DevicePricing({ menu }) {
    const navigate = useNavigate();
    const [t, setT] = useState(0);

    const [searchParams, setSearchParams] = useSearchParams();

    const [device, setDevice] = useState(null);
    const [deviceBalanceE6, setDeviceBalanceE6] = useState(0);
    const [minPricePerSecondE6, setMinPricePerSecondE6] = useState(null);
    const e6 = 100000;

    function getDevice(device_id) {
        axios.get(
            process.env.REACT_APP_API_HOST + `/devices/${device_id}/`,
            {}
        ).then(
            (response) => {
                setDevice(response.data);
                setMinPricePerSecondE6(response.data.min_price_per_second_e6);
            }
        )
    }

    // TODO: remove this copy paste.
    function patchDevice(device_id, data) {
        axios.patch(
            process.env.REACT_APP_API_HOST + `/devices/${device_id}/`,
            data
        ).then(
            (response) => {
                navigate('/devices/');
            }
        )
    }

    function getDeviceBalanceE6(device_id) {
        axios.get(
            process.env.REACT_APP_API_HOST + `/device/balance/?device_id=${device_id}`,
            {
                headers: {
                    'Authorization': localStorage.getItem('token'),
                }
            }
        ).then(
            (response) => {
                setDeviceBalanceE6(response.data.balance);
            }
        ).catch(
            (error) => {

            }
        )
    }

    useEffect(
        () => {
            getDevice(searchParams.get('device_id'));
            getDeviceBalanceE6(searchParams.get('device_id'));
            setTimeout(
                () => {
                    setT(t + 1);
                },
                1000,
            )
        },
        [],
    )

    return (
        <div align='left'>
            {menu}
            <DeviceHeader title='Device Pricing' />
            <V2Card>
                <div>
                    <div>
                        Enter here the price you are happy to sell 1 second of advertising on this device.
                    </div>
                    <div
                        style={{
                            marginTop: '1em',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                        }}>
                        <InputText
                            value={minPricePerSecondE6}
                            onChange={
                                (e) => {
                                    const new_value = e.target.value;
                                    if (new_value < 0) {
                                        return;
                                    }
                                    setMinPricePerSecondE6(new_value);
                                }
                            }
                            type='number'
                            className='text-input1'
                        />
                        <div style={{ marginLeft: '0.2em' }}>
                            <i className="pi pi-times" style={{ fontSize: '1.5rem' }} />
                        </div>
                        <h2 style={{ marginLeft: '0.2em' }}>
                            {1 / e6}
                        </h2>
                    </div>
                    <div>
                        <div style={{ marginLeft: '0.2em' }}>
                            = {minPricePerSecondE6 / e6} EUR/second
                        </div>
                    </div>
                </div>
                <div>
                    <div style={{ marginTop: '1em' }}>
                        <h3>
                            Advertisers will be charged at least {minPricePerSecondE6 / e6} EUR for every second while running an ad.
                        </h3>
                    </div>
                </div>
                <div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                        <i
                            className="pi pi-calculator"
                            style={{
                                fontSize: '1.9rem',
                                marginRight: '0.2em',
                            }}
                        />
                        <h3>
                            Revenue Predictor
                        </h3>
                    </div>
                    <div>
                        Assuming the following:
                        <ul>
                            <li>
                                device will be online for the entire month;
                            </li>
                            <li>
                                there will always advertisers happy to pay the requested price;
                            </li>
                            <li>
                                ads are served during the day only (18 h / day)
                            </li>
                        </ul>
                    </div>
                    <div>
                        You may get:
                    </div>
                    <h3>
                        {(minPricePerSecondE6 / e6 * 60 * 60 * 18 * 30).toFixed(2)} EUR / month
                    </h3>
                </div>
                <div>
                    <h3>
                        Eligible Revenue
                    </h3>
                    <h3>
                        {deviceBalanceE6 / e6} EUR
                    </h3>
                </div>
                <div>
                    <Button
                        label='Save'
                        severity='success'
                        onClick={
                            () => patchDevice(
                                searchParams.get('device_id'),
                                {
                                    min_price_per_second_e6: minPricePerSecondE6,
                                }
                            )
                        }
                        size='small'
                        outlined
                    />
                </div>
            </V2Card>
        </div>
    );
}

export default DevicePricing;